export default __webpack_public_path__ + "static/ti_hovervan_block-4c61ed8b954ef130dcf981459c149b08.svg";